module.exports = __webpack_public_path__ + "img/pano-credit-one.f4adf4e2.jpg";